<template>
  <section class="dp-layout parking-page parking-admin-page">
    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction"></toolbar>

      <div class="parking-table-panel">
        <div class="panel-header">
          <div class="panel-title">停车场管理员<span class="count">共 {{ total }} 人</span></div>
          <span class="panel-tip">独立名单，管理全校：H5 端教师车牌审批、全校车牌维护、访客邀请均以此名单判定权限</span>
        </div>

        <div class="tbl-scroll-host">
          <el-table :data="rows" v-loading="loading" class="custom-tbl" style="width:100%" height="100%">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="姓名" min-width="140">
              <template slot-scope="scope">{{ scope.row.teacherName || scope.row.name || '-' }}</template>
            </el-table-column>
            <el-table-column label="状态" width="90">
              <template slot-scope="scope">
                <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="small">
                  {{ scope.row.enabled ? '启用' : '停用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
            <el-table-column label="添加时间" width="160">
              <template slot-scope="scope"><span class="time-text">{{ formatDateTime(scope.row.createTime) }}</span></template>
            </el-table-column>
            <el-table-column v-if="can('openEdit') || can('remove')" label="操作" width="160" fixed="right" align="center">
              <template slot-scope="scope">
                <div class="table-op-pair">
                  <el-button v-if="can('openEdit')" type="text" class="table-op-link" @click="openEdit(scope.row)">编辑</el-button>
                  <el-button v-if="can('remove')" type="text" class="table-op-link table-op-link--danger" @click="remove(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="float:right"
          ></el-pagination>
        </el-col>
      </div>
    </section>

    <el-dialog
      :title="form.id ? '编辑停车场管理员' : '新增停车场管理员'"
      :visible.sync="dialogVisible"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="教职工" prop="teacherId">
          <div class="parking-picked-row">
            <span v-if="form.teacherId" class="picked-name">已选 {{ form.name }}</span>
            <span v-else class="picked-empty">请选择一名教职工</span>
            <el-button size="small" icon="el-icon-user" @click="pickerVisible = true">选择教职工</el-button>
            <el-button v-if="form.teacherId" type="text" size="small" @click="clearPicked">清空</el-button>
          </div>
          <div class="parking-form-tip">从通讯录选择，仅绑定一人</div>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <person-scope-picker-dialog
      :visible.sync="pickerVisible"
      directory-scope="internal"
      :show-scope-tabs="false"
      :scope-department-id="schoolId || 0"
      :value="form.teacherId || null"
      :label="form.name"
      title="选择停车场管理员"
      @confirm="onPicked"
    />
  </section>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import PersonScopePickerDialog from '@/components/PersonScopePickerDialog'
import {
  getParkingAdminList,
  addParkingAdmin,
  editParkingAdmin,
  deleteParkingAdmin
} from '@/api/parking'
import { toCamel, readPage, formatDateTime, loadButtonFuncs, buildToolbarButtons } from './parkingUtils'

const TOOLBAR_BUTTONS = [
  { name: '查询', Func: 'handleSearchBtn', icon: 'el-icon-search', always: true },
  { name: '新增管理员', Func: 'openCreate', icon: 'el-icon-plus', btnType: 'primary' }
]

export default {
  name: 'ParkingAdmin',
  components: { Toolbar, PersonScopePickerDialog },
  data() {
    return {
      schoolId: null,
      loading: false,
      saving: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      searchName: '',
      dialogVisible: false,
      pickerVisible: false,
      form: this.emptyForm(),
      rules: {
        teacherId: [{ required: true, type: 'number', min: 1, message: '请选择教职工', trigger: 'change' }]
      },
      buttonFuncs: [],
      buttonList: [],
      searchList: [
        { key: 'searchName', label: '姓名', width: '150px' }
      ]
    }
  },
  watch: {
    '$store.state.activeSchoolId': {
      immediate: true,
      handler(value) {
        this.schoolId = value
        this.page = 1
        if (value) this.load()
      }
    }
  },
  created() {
    this.buttonFuncs = loadButtonFuncs(this.$route.path)
    this.buttonList = buildToolbarButtons(TOOLBAR_BUTTONS, this.buttonFuncs)
  },
  methods: {
    formatDateTime,
    /** 当前角色是否分配了该按钮权限 */
    can(func) {
      return this.buttonFuncs.includes(func)
    },
    callFunction(item) {
      if (item.Func && typeof this[item.Func] === 'function') this[item.Func](item)
    },
    emptyForm() {
      return { id: 0, campusId: 0, teacherId: 0, name: '', enabled: true, remark: '' }
    },
    handleSearchBtn(item) {
      const s = (item && item.search) || {}
      this.searchName = s.searchName || ''
      this.page = 1
      this.load()
    },
    async load() {
      if (!this.schoolId) return
      this.loading = true
      try {
        const params = { schoolId: this.schoolId, page: this.page, intPageSize: this.pageSize, name: this.searchName }
        const res = await getParkingAdminList(params)
        if (res.data && res.data.success) {
          const { list, total } = readPage(res)
          this.rows = list
          this.total = total
        } else {
          this.$message.error((res.data && res.data.msg) || '管理员列表加载失败')
        }
      } catch (e) {
        this.$message.error('管理员列表加载失败')
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.load()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.load()
    },
    openCreate() {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      this.form = this.emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    openEdit(row) {
      const data = toCamel(row)
      this.form = {
        ...this.emptyForm(),
        id: data.id,
        campusId: 0,
        teacherId: Number(data.teacherId) || 0,
        name: data.teacherName || data.name || '',
        enabled: data.enabled !== false,
        remark: data.remark || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    /** 通讯录选人回调 */
    onPicked(person) {
      if (!person) return
      this.form.teacherId = Number(person.id) || 0
      this.form.name = person.name || ''
      this.$nextTick(() => this.$refs.form && this.$refs.form.validateField('teacherId'))
    },
    clearPicked() {
      this.form.teacherId = 0
      this.form.name = ''
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const data = { ...this.form, schoolId: this.schoolId }
          const res = this.form.id ? await editParkingAdmin(data) : await addParkingAdmin(data)
          if (res.data && res.data.success) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.load()
          } else {
            this.$message.error((res.data && res.data.msg) || '保存失败')
          }
        } finally {
          this.saving = false
        }
      })
    },
    remove(row) {
      this.$confirm(`确定删除停车场管理员「${row.teacherName || row.name}」吗？`, '提示', { type: 'warning' })
        .then(async () => {
          const res = await deleteParkingAdmin(row.id)
          if (res.data && res.data.success) {
            this.$message.success('删除成功')
            this.load()
          } else {
            this.$message.error((res.data && res.data.msg) || '删除失败')
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style>
@import './parking-page.css';
</style>
